import { render, staticRenderFns } from "./ModalSuggestSkill.vue?vue&type=template&id=79bab0b2&"
import script from "./ModalSuggestSkill.vue?vue&type=script&lang=js&"
export * from "./ModalSuggestSkill.vue?vue&type=script&lang=js&"
import style0 from "./ModalSuggestSkill.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormInput: require('/workspace/components/Form/FormInput.vue').default})
